
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { UiSelect } from '../keen-ui'
import InputErrors from '../shared/input-errors.component.vue'
import InputLabel from '../shared/input-label.component.vue'
import StringArrayInput from '../shared/string-array-input.component.vue'

export default defineComponent({
  name: 'StringArrayServiceConfigField',
  components: {
    UiSelect,
    InputLabel,
    InputErrors,
    StringArrayInput,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    value: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    required: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    errors: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    itemErrors: {
      type: Object as PropType<Record<string, Array<string>>>,
      default: () => ({}),
    },
    options: {
      type: Array as PropType<Array<string>>,
    },
    minlength: {
      type: Number,
    },
    maxlength: {
      type: Number,
    },
  },
  data() {
    return {
      baseClass: 'epb-string-array-service-config-field',
      dirty: false,
    }
  },
})
